import {Injectable} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {FilledCustomValueDto} from "@server-models";
import {SharedIssueBaseService} from "@shared/components/issues/services/shared-issue-base.service";

@Injectable({
  providedIn: 'root',
})
export abstract class SharedIssueStereotypeBaseService extends SharedIssueBaseService {

  protected getCustomPropertyValues(formGroup: FormGroup): FilledCustomValueDto[] {
    const customValues = formGroup.get('CustomValues')?.value;
    return Array.isArray(customValues) ? customValues : [];
  }

}
